import { useNavigate } from 'react-router-dom';

interface Props {
  /** 页面名称,如「因子工作台」 */
  title?: string;
}

/**
 * 移动端占位:重研究页(多 Tab / 宽表 / 脚本编辑器)在手机上无法有效操作,
 * 显示友好提示 + 返回高频页的入口。桌面端不会渲染(调用方按 useIsMobile 判定)。
 */
export default function DesktopOnlyNotice({ title }: Props) {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-8 text-center">
      <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
        <i className="ri-computer-line text-3xl text-gray-400"></i>
      </div>
      <h2 className="text-base font-semibold text-gray-800 mb-1">
        {title ? `${title}建议在电脑端使用` : '此页面建议在电脑端使用'}
      </h2>
      <p className="text-sm text-gray-500 leading-relaxed mb-6 max-w-xs">
        这是研究/操作类页面,包含宽表格、多标签与编辑器,手机屏幕不便操作。
        请在电脑上打开;手机上可查看下面的高频页。
      </p>
      <div className="flex gap-3">
        <button
          onClick={() => navigate('/app/recommendations')}
          className="px-4 py-2 rounded-lg bg-teal-600 text-white text-sm font-medium"
        >
          今日推荐
        </button>
        <button
          onClick={() => navigate('/app/my-portfolio')}
          className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-medium"
        >
          我的持仓
        </button>
      </div>
    </div>
  );
}
